import shareApi from '@/assets/functions/shareApi';
import { sync } from 'vuex-pathify';

export const webShareMixin = {
  data: () => ({}),
  mounted () {
  },
  computed: {
    showShareDialog: sync('share/showShareDialog'),
    shareTitle: sync('share/shareTitle'),
    shareText: sync('share/shareText'),
    shareUrl: sync('share/shareUrl'),
  },
  methods: {
    shareApi,
    webShare (title, text, url) {
      if (!shareApi(title, text, url)) {
        this.shareTitle = title;
        this.shareText = text;
        this.shareUrl = url;

        this.showShareDialog = true;
      }
    },
  },
};